module.exports = __webpack_public_path__ + "static/assets/57ba690c51bb8e13500a22efee55c96b.png";